$(document).ready(function () {
    $('.js-go-to-url').on('click', function () {
        window.location.href = $(this).data('url')
    })
    $('.js-go-to-back-url').on('click', function () {
        window.history.back();
    })
    $('.js-select-init').select2({
        placeholder: "Select",
        width:'100%',
        minimumResultsForSearch: Infinity,
    });
    // $(".js-invoice-email").select2({
    //     placeholder: "Select",
    //     width:'100%',
    //     minimumResultsForSearch: Infinity,
    //
    // });

    $('.js-entries-per-page').select2({
        minimumResultsForSearch: Infinity,
    });
    $('#coins-received-modal').modal('show');
    jQuery.validator.setDefaults({
        errorPlacement: function (error, element) {
            error.addClass('invalid-feedback');
            let errorText = $(error).text()
            $(element).parent().closest('.form-group').find('.invalid-feedback strong').text(errorText);
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid');
            if($(element).hasClass('js-validate-select')){
                $(element).next().addClass('is-invalid')
            }
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid');
            if($(element).hasClass('js-validate-select')){
                $(element).next().removeClass('is-invalid')
            }
        }
    });

    $('input[name="search-all"]').on('keypress', function (e) {
        if (e.which === 13) { // Enter key code
            $(this).closest('.js-table-advanced-search').find('.js-search-button').click();
        }
    });
})
$.extend(jQuery.validator.messages, {
    required: "This field is required.",
    remote: "Please fix this field.",
    email: "Please enter a valid email address.",
    url: "Please enter a valid URL.",
    date: "Please enter a valid date.",
    dateISO: "Please enter a valid date (ISO).",
    number: "Please enter a valid number.",
    digits: "Please enter only digits.",
    creditcard: "Please enter a valid credit card number.",
    equalTo: "Please enter the same value again.",
    accept: "Please enter a value with a valid extension.",
    maxlength: jQuery.validator.format("Please enter no more than {0} characters."),
    minlength: jQuery.validator.format("Please enter at least {0} characters."),
    rangelength: jQuery.validator.format("Please enter a value between {0} and {1} characters long."),
    range: jQuery.validator.format("Please enter a value between {0} and {1}."),
    max: jQuery.validator.format("Enter date earlier than {0}."),
    min: jQuery.validator.format("Enter date later than {0}.")
});




